/**
 * AURORE : pas de disque du tout, une tache de lumiere qui change lentement de forme, avec un
 * coeur plus clair qui derive a son propre rythme a l'interieur.
 *
 * L'IDEE, EN UN MOT : contemporain, doux. Les deux couches respirent a contretemps — onze
 * secondes pour la forme, huit pour le coeur — pour que la boucle ne se laisse jamais compter.
 *
 * PAS DE DISQUE, DONC PAS DE ROND NI D'OMBRE DE BULLE : la tache fait 76 px et deborde en bas a
 * droite du lanceur de 64. C'est la raison meme pour laquelle un look ne peut pas etre un contenu
 * du bouton, qui rogne ce qui depasse.
 *
 * AU TEMPS FORT, un eclair la traverse en diagonale. A L'OUVERTURE, elle se recueille, sa forme
 * se fige et une croix de lumiere apparait en son centre.
 *
 * CE FICHIER N'IMPORTE RIEN, PAR CONTRAT, et sa feuille est un gabarit de chaine : deux accents
 * graves dans le fichier, pas un de plus.
 */
export default {
  id: 'aurore',

  css: `
.woot-lanceur[data-look="aurore"] .woot-aurore__tache {
  position: absolute;
  right: -6px;
  bottom: -6px;
  width: 76px;
  height: 76px;
  border-radius: 60% 40% 55% 45% / 50% 60% 40% 50%;
  background: var(--client);
  background: linear-gradient(135deg, color-mix(in srgb, var(--client) 50%, white) 0%, var(--client) 55%, color-mix(in srgb, var(--client) 55%, #1a1040) 100%);
  box-shadow: 0 14px 36px rgba(16, 19, 23, .3);
  box-shadow: 0 14px 36px color-mix(in srgb, var(--client) 45%, transparent);
  overflow: hidden;
  transition: transform .55s cubic-bezier(.2, .8, .2, 1), filter .3s ease;
}

.woot-lanceur[data-look="aurore"][data-etat="repos"] .woot-aurore__tache,
.woot-lanceur[data-look="aurore"][data-etat="attention"] .woot-aurore__tache {
  animation: woot-aurore-morph 11s ease-in-out infinite;
}

@keyframes woot-aurore-morph {
  0%, 100% { border-radius: 60% 40% 55% 45% / 50% 60% 40% 50%; transform: rotate(0); }
  33% { border-radius: 45% 55% 40% 60% / 55% 45% 60% 40%; transform: rotate(7deg); }
  66% { border-radius: 55% 45% 60% 40% / 40% 55% 45% 60%; transform: rotate(-5deg); }
}

/* Le coeur : la seconde couche, plus claire, sur une autre boucle. */
.woot-lanceur[data-look="aurore"] .woot-aurore__coeur {
  position: absolute;
  inset: 14% 10% 8% 16%;
  border-radius: 55% 45% 50% 50% / 45% 55% 45% 55%;
  background: radial-gradient(circle at 40% 38%, rgba(255, 255, 255, .5) 0%, rgba(255, 255, 255, .12) 45%, transparent 70%);
}

.woot-lanceur[data-look="aurore"][data-etat="repos"] .woot-aurore__coeur,
.woot-lanceur[data-look="aurore"][data-etat="attention"] .woot-aurore__coeur {
  animation: woot-aurore-coeur 8s ease-in-out infinite;
}

@keyframes woot-aurore-coeur {
  0%, 100% { border-radius: 55% 45% 50% 50% / 45% 55% 45% 55%; transform: translate(0, 0) rotate(0); }
  50% { border-radius: 45% 55% 55% 45% / 55% 45% 55% 45%; transform: translate(-5px, 4px) rotate(-12deg); }
}

/* LE TEMPS FORT : un eclair traverse la tache, une fois, en diagonale. */
.woot-lanceur[data-look="aurore"] .woot-aurore__lueur {
  position: absolute;
  inset: -10%;
  background: linear-gradient(115deg, transparent 35%, rgba(255, 255, 255, .6) 50%, transparent 65%);
  transform: translateX(-130%);
}

.woot-lanceur[data-look="aurore"][data-etat="attention"] .woot-aurore__lueur { animation: woot-aurore-eclair 1.2s cubic-bezier(.4, 0, .2, 1); }
@keyframes woot-aurore-eclair { to { transform: translateX(130%); } }

/* AU SURVOL elle s'avive et respire plus vite. Le selecteur porte [data-etat] pour peser autant
   que les regles d'etat au-dessus : sans ce poids, le raccourci animation des etats gagnait et la
   duree du survol ne s'appliquait jamais. */
.woot-lanceur[data-look="aurore"][data-etat]:hover .woot-aurore__tache { filter: saturate(1.35) brightness(1.06); animation-duration: 5s; }

/* Le cartouche d'Aurore est du verre : la surface du theme, allegee. Jamais du blanc pose sur une
   page dont on ne sait rien. Le repli sert les navigateurs sans color-mix. */
.woot-lanceur[data-look="aurore"] .woot-lanceur__cartouche {
  background: var(--woot-surface);
  background: color-mix(in srgb, var(--woot-surface) 72%, transparent);
  backdrop-filter: blur(10px);
}

/* OUVERT : la tache se recueille et se fige, la croix de lumiere apparait en son centre. Elle
   passe devant : sans ce niveau, le coeur la recouvrirait. */
.woot-lanceur[data-look="aurore"] .woot-lanceur__croix {
  width: 22px;
  height: 22px;
  margin: -11px;
  z-index: 1;
}

.woot-lanceur[data-look="aurore"] .woot-lanceur__croix::before,
.woot-lanceur[data-look="aurore"] .woot-lanceur__croix::after {
  box-shadow: 0 0 10px 2px rgba(255, 255, 255, .45);
}

.woot-lanceur[data-look="aurore"][data-etat="ouvert"] .woot-aurore__tache { transform: scale(.84); }
`,

  monter: conteneur => {
    const tache = document.createElement('div');
    tache.className = 'woot-aurore__tache';

    const coeur = document.createElement('span');
    coeur.className = 'woot-aurore__coeur';
    const lueur = document.createElement('span');
    lueur.className = 'woot-aurore__lueur';
    tache.appendChild(coeur);
    tache.appendChild(lueur);

    const croix = document.createElement('span');
    croix.className = 'woot-lanceur__croix';

    conteneur.appendChild(tache);
    conteneur.appendChild(croix);
  },

  // AURORE EST DU CSS PUR : les quatre gestes existent parce que le modele les appelle pour tous
  // les looks, et parce que certains — une bouche qui parle en SMIL — en ont besoin. Ici l'attribut
  // d'etat porte tout, et il n'y a rien a mettre en pause que la feuille n'arrete deja.
  gestes: {
    attention: () => {},
    ouvrir: () => {},
    fermer: () => {},
    reduireLeMouvement: () => {},
  },
};
